import { SORT_BY_CONFIG, DEFAULT_SORT_PARAM } from 'site-modules/shared/constants/lease-deals/lease-deals';

export const getSortParamWithFallback = sortBy => (SORT_BY_CONFIG[sortBy] ? sortBy : DEFAULT_SORT_PARAM);
